<template>
  <AiDialog v-model="dialogVisible" class="ai-customer-select" width="800px">
    <template #header>
      <div class="ai-customer-select__header-title">
        <span class="ai-customer-select__header-name">选择{{ title }}</span>
        <template v-if="showPool">
          <CustomerTypeTabs v-model="customerType" :options="customerTypeOptions" />
          <span class="ai-customer-select__header-tip">不支持同时选择两类{{ title }}</span>
        </template>
      </div>
    </template>
    <template #default>
      <CustomerSelect
        v-if="dialogVisible"
        ref="customerRef"
        :business-type="props.businessType"
      ></CustomerSelect>
    </template>
    <template #footer>
      <el-button size="medium" @click="toCancel">取消</el-button>
      <el-button size="medium" type="primary" @click="toConfirm">确定</el-button>
    </template>
  </AiDialog>
</template>

<script setup>
import xbb from '@xbb/xbb-utils'
import {
  onMounted,
  nextTick,
  computed,
  ref,
  defineProps,
  defineEmits,
  watch,
  provide,
  inject,
  toRef
} from 'vue'
import AiDialog from '@/components/ai-dialog/index.vue'
import CustomerSelect from './customer-select.vue'
import CustomerTypeTabs from '@/components/switch-tabs.vue'
// emit
const emit = defineEmits(['update:visible', 'confirm'])
// props
const props = defineProps({
  visible: Boolean,
  // 默认初始值
  defaultValue: {
    type: Array,
    default: () => []
  },
  // 选择数据上限控制
  selectLimit: {
    type: Number,
    default: -1
  },
  defaultProps: {
    type: Object,
    default: () => ({
      label: 'name',
      key: 'key'
    })
  },
  businessType: {
    type: Number,
    default: 100,
    require: true
  },
  title: {
    type: String,
    default: '数据'
  }
})

const showPool = computed(() => {
  // 只有客户和线索才有公海池
  if (props.businessType === 100 || props.businessType === 8000) {
    return true
  }
  return false
})

// data
const customerRef = ref(null)
const templateId = inject('templateId', ref(''))
const customerType = ref(templateId.value ? 1 : 0)
provide('customerType', customerType)
provide('title', toRef(props, 'title'))
// computed
const dialogVisible = computed({
  get: () => props.visible,
  set: (val) => emit('update:visible', val)
})
const customerTypeOptions = computed(() => [
  {
    label: `库内${props.title}`,
    value: 0
  },
  {
    label: `公海池${props.title}`,
    value: 1
  }
])
// watch
watch(
  () => dialogVisible.value,
  (val) => {
    val && init()
  }
)
watch(
  () => customerType.value,
  () => {
    nextTick(() => {
      customerRef.value?.setData([])
    })
  }
)
// methods
const init = () => {
  nextTick(() => {
    customerRef.value.setData(xbb.deepClone(props.defaultValue))
  })
}
const toCancel = () => {
  dialogVisible.value = false
}
const toConfirm = () => {
  emit('confirm', xbb.deepClone(customerRef.value.getData()))
  toCancel()
}
// lice-cycle
onMounted(() => {})
</script>

<style lang="less">
.ai-customer-select {
  .ai-dialog-container__header {
    font-size: 16px;
    line-height: normal;
    color: #323233;
    .el-dialog__headerbtn {
      height: 48px;
    }
  }

  &__header-title {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 720px;
    max-width: calc(100% - 32px);
    height: 32px;
    font-family: 'PingFang SC';
  }

  &__header-name {
    color: #323233; // 文字/Text-4 强调正文标题
    font-size: 18px; // 二级文字/加粗
    font-weight: 600;
    line-height: 26px;
    white-space: nowrap;
  }

  &__header-tip {
    color: #9e9e9e;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    white-space: nowrap;
  }
}
</style>
